import {
    useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import requests from 'app/requests/Order/Order.requests'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'

import columns from './orderChangeSummary.columns'
import useStyles from './OrderChangeSummary.style'
import {
    Modification,
} from './OrderChangeSummary.types'

const OrderChangeSummary = ({
    orderNumber,
}: { orderNumber: string }) => {
    const {
        classes,
    } = useStyles()

    const urlConfig = useMemo(() => {
        const url = requests.getModifications({
            orderNumber,
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'Order',
        }
    }, [orderNumber])

    const load: (params: any) => Promise<{
        items: Modification,
        matches: number
    }> = useLoadDtoForSkyNetTable(urlConfig)

    return (
        <RichTable
            configName="OrderChangeSummaryTable"
            name="Modification"
            load={load}
            columns={columns}
            className={classes.tableContent}
            classNames={{
                contentWrapper: classes.tableContentWrapper,
            }}
            uniqField="id"
        />
    )
}

export default OrderChangeSummary
